var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.listLoading,
          expression: "listLoading",
        },
      ],
      staticClass: "red-packet-statistics-container",
    },
    [
      _c(
        "div",
        { staticClass: "list-container" },
        [
          _c(
            "el-form",
            {
              staticClass: "compact-search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "活动名称：" } },
                [_c("el-tag", [_vm._v(_vm._s(_vm.activityName))])],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "序号：" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      size: "small",
                      placeholder: "请输入序号",
                    },
                    model: {
                      value: _vm.searchForm.initiatorId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "initiatorId", $$v)
                      },
                      expression: "searchForm.initiatorId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "发起人手机号码：" } },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      size: "small",
                      placeholder: "请输入发起人手机号码",
                    },
                    model: {
                      value: _vm.searchForm.mobile,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mobile", $$v)
                      },
                      expression: "searchForm.mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        size: "small",
                        placeholder: "请选择状态",
                      },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "不限", value: "" } }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "发放成功", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "未完成未发放", value: "2" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "已完成未发放", value: "3" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleExport },
                    },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          key: _vm.initiatorTableKey,
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "", stripe: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "initiatorIdd", label: "序号", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "initiator", label: "发起者信息", width: "300" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "user" }, [
                      _c(
                        "div",
                        { staticClass: "user-avatar" },
                        [
                          _c("el-image", {
                            staticStyle: { width: "60px", height: "60px" },
                            attrs: { src: row.avatar, fit: "cover" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", [_vm._v("用户Id：" + _vm._s(row.userId))]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("昵    称：" + _vm._s(row.nickname)),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v("手机号码：" + _vm._s(row.mobile))]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "发起时间：" + _vm._s(row.createTimeFormatter)
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "helpers", label: "助力者信息" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      { staticClass: "row-helper-container" },
                      _vm._l(row.helpers, function (helper) {
                        return _c(
                          "div",
                          {
                            key: helper.id,
                            staticClass: "user row-helper-item",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "user-avatar" },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "60px",
                                    height: "60px",
                                  },
                                  attrs: { src: helper.avatar, fit: "cover" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", [
                                _vm._v("用户Id：" + _vm._s(helper.userId)),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v("昵    称：" + _vm._s(helper.nickname)),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v("手机号码：" + _vm._s(helper.mobile)),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  "助力时间：" +
                                    _vm._s(helper.createTimeFormatter)
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "initiatorStatusName", label: "状态", width: "80" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "prizeStatusName",
              label: "中奖状态",
              width: "150",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("div", [_vm._v(_vm._s(row.prizeStatusName))]),
                    _vm._v(" "),
                    row.prizeCouponName
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#409EFF",
                            },
                          },
                          [
                            _c("div", [_vm._v(_vm._s(row.prizeCouponId))]),
                            _vm._v(" "),
                            _c("div", [_vm._v(_vm._s(row.prizeCouponName))]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v("￥" + _vm._s(row.prizeCouponMoney)),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              row.prizeStatus === 4 || row.prizeStatus === 1,
                            expression:
                              "row.prizeStatus === 4 || row.prizeStatus === 1",
                          },
                        ],
                        staticStyle: { "margin-bottom": "20px" },
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleResendInitiator(row)
                          },
                        },
                      },
                      [_vm._v("补发")]
                    ),
                    _vm._v(" "),
                    _c("br", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: row.prizeStatus === 4 || row.prizeStatus === 1,
                          expression:
                            "row.prizeStatus === 4 || row.prizeStatus === 1",
                        },
                      ],
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.handleHelperDetail(row)
                          },
                        },
                      },
                      [_vm._v("助力明细")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes,prev, pager, next,jumper",
              "page-size": _vm.searchForm.limit,
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: "助力明细",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              key: _vm.helperTableKey,
              staticStyle: { width: "100%" },
              attrs: { data: _vm.currHelpers, border: "", stripe: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "nickname", label: "昵称", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "手机号码", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTimeFormatter",
                  label: "助力时间",
                  width: "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "prizeStatusName",
                  label: "中奖状态",
                  width: "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  row.prizeStatus === 4 ||
                                  row.prizeStatus === 1,
                                expression:
                                  "row.prizeStatus === 4 || row.prizeStatus === 1",
                              },
                            ],
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleResendHelper(row)
                              },
                            },
                          },
                          [_vm._v("补发")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }